var divider_viewer_rtlignore_default = {
  "divider-container": "kqxLr",
  "divider-container--double": "P-4RE",
  "divider": "-ccv-",
  "divider--single": "_0EpKg",
  "divider--double": "giEPD",
  "divider--dashed": "sk9Si",
  "divider--dotted": "_7rnu-",
  "divider--small": "_7Wpul",
  "divider--medium": "KwqXe",
  "divider--large": "uIWej",
  "divider--left": "MI5A-",
  "divider--center": "XzBkR",
  "divider--right": "o8MXT",
  "svgFixerContainer": "Oh3Zo",
  "emptyChar": "k2tT9"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
